// Props
interface Props {
  years: number;
}
interface PropsReturn {
  currentYear: number; 
  recentYears: number[];
}

// Main function
export const useGetLastYears: ({ years }: Props) => PropsReturn = 
  ({ years }) => {
  const currentYear: number = new Date()?.getFullYear()
  const recentYears = Array(years)?.fill('')?.map((value: string, index: number) => currentYear - index)
  return { currentYear, recentYears }
}
